import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import TopBarNav from '../common/TopBarNav'
import { getIndirectDashboardIcon } from '../common/UtilsIcons'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Icon from 'antd/es/icon'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as indirectActions from '../../actions/indirects/IndirectActions'
import { IndirectStyles } from './IndirectStyles'
import { bindActionCreators } from 'redux';
import { Backdrop, CircularProgress } from '@material-ui/core'

const IndirectDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);

    useEffect(() => {
        handleOpenBackdrop()
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/indirect',
            linkLegend: 'Tablero',
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Indirect_Dashboard(props.userLanguage, props.userToken, params.branchOfficeId, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h5>Indirectos</h5>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        {
                            props.dashboardItems.map((itemDashboard, index) => {
                                return (
                                    <Grid item xs={4} key={index}>
                                        <Card className={classes.borderRadius}>
                                            <CardActionArea component={RouterLink} to={`/indirect/listByStatus/${itemDashboard.key}&${params.branchOfficeId}`}>
                                                <CardHeader className={classes.cardHeader}
                                                    title={itemDashboard.key === 27 ? "Solicitudes con factura recibida" : itemDashboard.statusName}
                                                    titleTypographyProps={{ variant: 'h6' }}
                                                />
                                                <CardContent className={classes.dashboardAlign}>
                                                    <Icon type={getIndirectDashboardIcon(itemDashboard.key)} className={classes.dashboardIcon} theme="outlined" />
                                                    <br />
                                                    <br />
                                                    <Grid container item xs={12} className={classes.dashboardAlign}>
                                                        <br />
                                                        <Grid item xs={12}>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography>Total</Typography>
                                                            </Grid>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography>{itemDashboard.total}</Typography>
                                                                <br />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                );
                            }
                            )
                        }
                    </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItems: state.IndirectReducer.CountDasboard,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(indirectActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(IndirectStyles)(IndirectDashboard))